/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import ClassroomRouteLinkItem from './ClassroomRouteLinkItem';
import RosterIcon from 'icons/RosterIcon';
import {useUserContext} from 'app/UserContext';
import {useMidasJsonApi} from 'app/hooks';

const messages = defineMessages({
  title: {id: 'navigation.roster'},
});

const PdRosterItem = () => {
  const [{classroom}] = useUserContext();

  const [response] = useMidasJsonApi({
    url: `/midas/rest/pd-section/${classroom.sectionID}?fields=id`,
    expectedStatus: [200, 404],
  });

  // If a PD section does not exist, do not show the PD roster link (this item)
  if (!response.json?.section) {
    return null;
  }

  return (
    <ClassroomRouteLinkItem
      iconBefore={RosterIcon}
      route="midas/classroom/pd-roster"
      title={messages.title}
    />
  );
};

export default PdRosterItem;
